import {keyFigures} from "./src/KeyFigures";

(function (Drupal) { // closure
    'use strict';
    Drupal.behaviors.keyFigures = keyFigures;
}(Drupal));
